import React from 'react';
import { View } from 'react-native';
import Row from 'src/components/10-atoms/layout/Row';
import Pressable from 'src/components/10-atoms/pressables/Pressable';
import Typography from 'src/components/10-atoms/typography/Typography';
import { TypographyFontWeight, TypographyVariant, } from 'src/customizations/themes/10-parts/typography';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import stylesGenerator from './styles';
const SidebarItem = ({ label, to, renderIcon, badge, focused, }) => {
    const [{ styles, theme }] = useTheme(stylesGenerator);
    const color = focused
        ? theme.palette.primary.dark
        : theme.palette.typography.primary;
    return (React.createElement(Pressable, { to: to, "aria-current": focused ? 'page' : undefined },
        React.createElement(Row, { yAxis: "center", spacing: theme.spacing.standard.sm, style: [styles.item, focused && styles.itemFocused] },
            React.createElement(View, { style: styles.iconSlot },
                renderIcon(color, theme.iconSize.sm),
                !!badge && (React.createElement(Row, { style: styles.badge, bg: theme.palette.background.notificationBadge },
                    React.createElement(Typography, { variant: TypographyVariant.ICON_BADGE, color: theme.palette.background.main }, badge)))),
            React.createElement(Typography, { flex: true, numberOfLines: 1, ellipsizeMode: "tail", variant: TypographyVariant.BODY, color: color, fontWeight: focused ? TypographyFontWeight.MEDIUM : TypographyFontWeight.REGULAR }, label))));
};
export default SidebarItem;
